import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const AllCheckedIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>All Checked</title>
    <path d="M24,4A20,20,0,1,0,44,24,20,20,0,0,0,24,4Zm0,36A16,16,0,1,1,40,24,16,16,0,0,1,24,40Z" />
    <polygon points="21.38 35.85 11.7 26.17 15.94 21.93 21.38 27.36 32.77 15.97 37.02 20.21 21.38 35.85" />
  </IconBase>
);
